<div onsip-grid-placement-shelf>
  <div class="first-column">
    <section>
      <div class="mat-body-1 m-b-8 property-header">Name</div>
      <div [attr.data-cy]="E2eLocators.ADMIN_EXT_PHONE_NUM_VIEW_SHELF_NAME">
        {{ externalPhoneNum.name }}
      </div>
    </section>
    <section>
      <div class="mat-body-1 m-b-8 property-header">External phone number</div>
      <div [attr.data-cy]="E2eLocators.ADMIN_EXT_PHONE_NUM_VIEW_SHELF_NUMBER">
        {{ externalPhoneNum.username }}
      </div>
    </section>
    <section>
      <div class="mat-body-1 m-b-8 property-header">Report call minutes under</div>
      <div [attr.data-cy]="E2eLocators.ADMIN_EXT_PHONE_NUM_VIEW_SHELF_CALL_ACTIVITY">
        {{ externalPhoneNum.reportCallActivity }}
      </div>
    </section>
    <section>
      <div class="mat-body-1 m-b-8 property-header">Outbound caller ID</div>
      <div [attr.data-cy]="E2eLocators.ADMIN_EXT_PHONE_NUM_VIEW_SHELF_CALLER_ID">
        {{ externalPhoneNum.callerIdName }}
      </div>
    </section>
  </div>
  <div class="second-column">
    <section>
      <div class="mat-body-1 m-b-8 property-header">SIP address</div>
      <div [attr.data-cy]="E2eLocators.ADMIN_EXT_PHONE_NUM_VIEW_SHELF_ADDRESS">
        {{ externalPhoneNum.username + "@" + externalPhoneNum.domain }}
      </div>
    </section>
    <section>
      <div class="mat-body-1 m-b-8 property-header">{{ "ONSIP_I18N.EXTENSIONS" | translate }}</div>
      @if (externalPhoneNum.extensions && externalPhoneNum.extensions.length) {
      <div [attr.data-cy]="E2eLocators.ADMIN_EXT_PHONE_NUM_VIEW_SHELF_EXTENSION">
        @for (extension of externalPhoneNum.extensions; track extension) {
        <div>
          {{ extension | formatExtensions }}
        </div>
        }
      </div>
      } @else { No extensions added }
    </section>
  </div>
</div>
<div class="page-view-controls">
  <button
    [attr.data-cy]="E2eLocators.ADMIN_EXT_PHONE_NUM_VIEW_SHELF_EDIT_BTN"
    class="edit-btn"
    mat-flat-button
    color="primary"
    (click)="startEditing.emit()"
  >
    {{ "ONSIP_I18N.EDIT_INFO" | translate }}
  </button>
</div>
